// extracted by mini-css-extract-plugin
export default {"image":"sJ7bkl1"};